import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

const selectLogin = (state) => get('login', state);

const selectIsLoading = createSelector(selectLogin, (login) => login.isLoading);
export default selectIsLoading;
